import * as React from 'react';
import {Button, PriorityIcon, Flex, Icon, Title} from '@priority-software/priority-style-react';
import {MenuIcon} from './Menus/MenuIcon';
import BreadCrumbs from './BreadCrumbs/BreadCrumbs';
import {getLocalizedText, texts} from '../../../constants/TextConst';
import {renderGeneratorNewState} from '../../Searches/renderGenerator';
import {withTooltip} from '../../../components/Common/HOC/Custom/withTooltip';
import {IconWithTooltip} from './Menus/TopMenu';
import {withUpdate} from '../../../components/Common/HOC/withUpdate';
import {isPainted} from '../../../_shared/GWTBridge/invoke/netForm';
import {
    goToNextReconAccount,
    goToPrevReconAccount,
    pickReconAccount,
    getAccountName,
    getAccountNumber,
    getActiveAccount,
    getTotalAccounts,
    zoomAccount
} from '../../../_shared/GWTBridge/invoke/recon';
import {SearchesDropdown} from '../../Searches/components/SearchesDropdown';
import {selectFormSearch} from '../../Searches/actions/searchesList';
import {ClearSearchButton} from '../components/ClearSearchButton';
import quickSearchTextsxts from '../../QuickSearch/text';
import {EXIT_FORM} from '../consts/headerConsts';
import {hoverBtns} from '../../Searches/consts/enums';
import {isCurrentEntBPM} from '../../../_shared/GWTBridge/invoke/genPage';

export const SingleLineHeaderPanelComp = ({
    topMenu,
    isRTL,
    procEntity,
    setUpdateFunc,
    breadCrumbs,
    renderChooseBox,
    currentForm,
    searchesStore
}) => {
    const {closeButton} = topMenu;
    const tooltipPosition = isRTL ? 'bottom left' : 'bottom right';
    const isProc = procEntity && procEntity.procTitle;
    return (
        <section className="upper-section">
            <section className="breadcrumbs-choose">
                <BreadCrumbs breadCrumbs={breadCrumbs} {...procEntity} />
                {renderChooseBox()}
            </section>
            <section className="upper-menu">
                {isProc && (
                    <React.Fragment>
                        <ClearSearchButton
                            setUpdateFunc={setUpdateFunc}
                            formsStore={{searchesStore, currentForm}}
                        >
                            {getLocalizedText(texts.clearForm)}
                        </ClearSearchButton>
                        {renderSearchBox(searchesStore)}
                        <div className="buttons-row">
                            {renderSearchButton()}
                            {renderTopMenuButtons(topMenu, currentForm)}
                        </div>
                    </React.Fragment>
                )}
                {isCurrentEntBPM() && <div id="bpm-header-portal" />}
                <div className="buttons-row close-section">
                    <MenuIcon
                        name="close-icon"
                        item={closeButton}
                        tooltipPosition={tooltipPosition}
                    />
                </div>
            </section>
        </section>
    );
};

const renderSearchBox = searchesStore => {
    if (!searchesStore) {
        return null;
    }
    return (
        <SearchesDropdown
            selectedSearch={searchesStore.formSelected}
            searchesStore={searchesStore}
            onSelect={selectFormSearch}
            openingSide="leftSide"
            hoverBtnsArr={[hoverBtns.Default, hoverBtns.Edit]}
            onButtonClick={() => renderGeneratorNewState()}
        />
    );
};

const renderTopMenuButtons = (topMenu, currentForm) => {
    const {displayButton, filtersButton} = topMenu;
    return (
        <React.Fragment>
            {displayButton && (
                <IconWithTooltip
                    skin="standart"
                    icon={
                        currentForm &&
                        (isPainted(currentForm.table)
                            ? PriorityIcon.tableView
                            : PriorityIcon.recordView)
                    }
                    tooltip={displayButton && displayButton.tooltip}
                    onClick={displayButton && displayButton.action}
                />
            )}
            <IconWithTooltip
                skin="standart"
                icon={PriorityIcon.F11}
                tooltip={getLocalizedText(texts.F11) + ' (F11)'}
                active={filtersButton && filtersButton.isSelected && filtersButton.isSelected()}
                onClick={filtersButton && filtersButton.action}
            />
        </React.Fragment>
    );
};

const renderExtraMarkup = lowerMenu => {
    return (
        <div className="extra-buttons">
            <MenuIcon name="undo-icon" item={lowerMenu.undoButton} />
            <MenuIcon name="delete-icon" item={lowerMenu.deleteButton} />
        </div>
    );
};

const renderSearchButton = () => {
    return (
        <ButtonWithTooltip
            tooltip={getLocalizedText(texts.searchTooltip)}
            skin="secondary"
            prefixIcon={PriorityIcon.filter}
            onClick={renderGeneratorNewState}
        >
            {getLocalizedText(texts.advancedSearch)}
        </ButtonWithTooltip>
    );
};

export const ReconLineHeaderPanel = ({renderPageMenu, breadCrumbs, lowerMenu, isRTL}) => {
    const extraMarkup = renderExtraMarkup(lowerMenu);
    const searchButton = renderSearchButton();
    const accountsTotal = getTotalAccounts();
    const hasAccounts = Number(accountsTotal?.replace(',', '')) > 1;
    const accountFullTitle =
        getAccountNumber() && getAccountName() && `${getAccountNumber()} - ${getAccountName()}`;

    return (
        <section className="upper-section">
            <Flex justifyContent="flex-start" alignItems="baseline">
                {breadCrumbs?.length && (
                    <section className="bread-crumbs">
                        <Title skin="h3" textColor="primary-500">
                            {breadCrumbs[0].title}
                        </Title>
                    </section>
                )}
                {hasAccounts && (
                    <div className="account-buttons">
                        <Button
                            onClick={goToNextReconAccount}
                            componentClasses="account-navigation-button"
                            size="small"
                            skin="text"
                            icon={
                                <Icon
                                    icon={PriorityIcon.arrowLeft}
                                    componentClasses="accountNavigitionButtonIcon"
                                />
                            }
                        />
                        <Flex
                            direction="row"
                            alignItems="center"
                            componentClasses="account-content"
                        >
                            {isRTL ? (
                                <>
                                    <div className="account-link-container">
                                        <SelectAccountLink
                                            isRTL={isRTL}
                                            onClick={pickReconAccount}
                                        />
                                    </div>
                                    {hasAccounts && (
                                        <div className="account-total">
                                            {`(${getActiveAccount()}/${accountsTotal})`}
                                        </div>
                                    )}
                                    {accountFullTitle && (
                                        <span
                                            className="account-name"
                                            onClick={() => {
                                                zoomAccount();
                                            }}
                                        >
                                            {accountFullTitle}
                                        </span>
                                    )}
                                </>
                            ) : (
                                <>
                                    {accountFullTitle && (
                                        <span
                                            className="account-name"
                                            onClick={() => {
                                                zoomAccount();
                                            }}
                                        >
                                            {accountFullTitle}
                                        </span>
                                    )}
                                    {hasAccounts && (
                                        <div className="account-total">
                                            {`(${getActiveAccount()}/${accountsTotal})`}
                                        </div>
                                    )}
                                    <div className="account-link-container">
                                        <SelectAccountLink
                                            isRTL={isRTL}
                                            onClick={pickReconAccount}
                                        />
                                    </div>
                                </>
                            )}
                        </Flex>
                        <Button
                            onClick={goToPrevReconAccount}
                            componentClasses="account-navigation-button"
                            skin="text"
                            size="small"
                            icon={
                                <Icon
                                    icon={PriorityIcon.arrowRight}
                                    componentClasses="accountNavigitionButtonIcon"
                                />
                            }
                        />
                    </div>
                )}
            </Flex>
            {renderPageMenu(extraMarkup, searchButton)}
        </section>
    );
};

export const PrivTreeHeaderPanel = ({topMenu, isRTL, procEntity, breadCrumbs}) => {
    const {closeButton} = topMenu;
    const tooltipPosition = isRTL ? 'bottom left' : 'bottom right';
    const htmlButtons = (window as any).privTreeHtml;

    return (
        <section className="upper-section">
            <section className="breadcrumbs-choose">
                <BreadCrumbs breadCrumbs={breadCrumbs} {...procEntity} />
            </section>
            <section className="upper-menu">
                <div className="priv-tree" dangerouslySetInnerHTML={{__html: htmlButtons}} />
                <div className="close-section">
                    <MenuIcon
                        name="close-icon"
                        item={closeButton}
                        tooltipPosition={tooltipPosition}
                    />
                </div>
            </section>
        </section>
    );
};

export const QuickSearchTopHeaderPanel = ({topMenu, isRTL}) => {
    const {closeButton} = topMenu;
    const tooltipPosition = isRTL ? 'bottom left' : 'bottom right';
    return (
        <section className="upper-section popup-top">
            <div className="popup-top-section">
                <div
                    className="buttons back-to-list"
                    onClick={topMenu.closeButton && topMenu.closeButton.action}
                >
                    <Button
                        size="small"
                        icon={PriorityIcon.arrowLeft}
                        componentClasses="back-button"
                    />
                    <div className="back-title">{quickSearchTextsxts.closeandback}</div>
                </div>
                <MenuIcon
                    name="close-icon"
                    item={closeButton}
                    tooltipPosition={tooltipPosition}
                    role={EXIT_FORM}
                />
            </div>
        </section>
    );
};

interface SelectAccountLinkProps {
    isRTL: boolean;
    onClick: () => void;
    tooltip?: string;
}

const SelectAccountLinkBase = ({isRTL, onClick, tooltip}: SelectAccountLinkProps) => {
    const linkText = isRTL ? 'בחירת חשבון' : 'Select Account';

    return (
        <span className="select-account-link account-name" onClick={onClick}>
            {linkText}
        </span>
    );
};

const SelectAccountLink = ({isRTL, onClick}: SelectAccountLinkProps) => {
    const tooltipText = isRTL ? 'לחץ לבחירת חשבון ספציפי' : 'Click to choose a specific account';
    const SelectAccountWithTooltip = withTooltip(SelectAccountLinkBase);

    return <SelectAccountWithTooltip isRTL={isRTL} onClick={onClick} tooltip={tooltipText} />;
};

export const ButtonWithTooltip = withTooltip(Button);

export const SingleLineHeaderPanel = withUpdate(SingleLineHeaderPanelComp);
